module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_17-16ae4f45a4a6e06e4889c72926d644e0.png";